// IMPORTANT TO NOTE:
// Actions/states associated with "navigation" are only for recording purpose.
// ReactNavigation does not actually support using Redux as its state storage.
// We only use these Redux action/states to keep track of navigation status for
// analytics purpose.

import {createPromisedAction} from '/util/action.util';

export const NAVIGATE: string = 'NAVIGATION/NAVIGATE';

export const navigate = createPromisedAction(NAVIGATE, ['activeRoutes']);
